import React, { useState, PropsWithChildren } from 'react'
import { defaultProps } from './helpers/config'
import { generate } from './helpers/code'
import { getColor } from './helpers/utils'
import CaptchaContext from './Captcha.context'
import { CaptchaProviderProps } from './Captcha.types'

function CaptchaProvider({
  title,
  length,
  format,
  width,
  height,
  bgcolor,
  colors,
  fonts,
  resize,
  rotate,
  vertical,
  horizontal,
  shadow,
  lines,
  circles,
  children,
  ...props
}: PropsWithChildren<CaptchaProviderProps>) {
  const [code, setCode] = useState(generate(length, format))

  const refresh = () => {
    setCode(generate(length, format))
    return true
  }

  const captchaValue = {
    code: {
      value: code,
      length: Number.isInteger(length) ? length : defaultProps.length,
      format: typeof format === 'string' ? format : defaultProps.format,
      refresh
    },
    stage: {
      title: title !== undefined ? title : defaultProps.title,
      width: Number.isInteger(width) ? width : defaultProps.width,
      height: Number.isInteger(height) ? height : defaultProps.height,
      bgcolor: getColor(bgcolor, defaultProps.bgcolor)
    },
    style: {
      colors:
        Number.isInteger(colors) ||
        typeof colors === 'string' ||
        Array.isArray(colors)
          ? colors
          : defaultProps.colors,
      fonts:
        Number.isInteger(fonts) ||
        typeof fonts === 'string' ||
        Array.isArray(fonts)
          ? fonts
          : defaultProps.fonts,
      resize: typeof resize === 'boolean' ? resize : defaultProps.resize,
      rotate: typeof rotate === 'boolean' ? rotate : defaultProps.rotate,
      vertical:
        typeof vertical === 'boolean' ? vertical : defaultProps.vertical,
      horizontal:
        typeof horizontal === 'boolean' ? horizontal : defaultProps.horizontal,
      shadow: typeof shadow === 'boolean' ? shadow : defaultProps.shadow
    },
    elements: {
      lines: Number.isInteger(lines) ? lines : defaultProps.lines,
      circles: Number.isInteger(circles) ? circles : defaultProps.circles
    }
  }

  return (
    <CaptchaContext.Provider value={captchaValue} {...props}>
      {children}
    </CaptchaContext.Provider>
  )
}

export { CaptchaProvider }
export default CaptchaProvider
